export default __webpack_public_path__ + "static/media/grid_view_icon_active.00956d8d.svg";